<template>
    <div class="d-flex justify-content-between gap-3">
        <div class="col-7">
            <job-editor v-on:tabChange="showTab" v-on:onLintFailure="onLintFailure" :editMode="editMode"
                :jobType="jobType" v-model="yamlContent" :activeTab="activetab"></job-editor>
        </div>
        <div class="col-5">
            <div class="error-alert d-flex justify-content-start align-items-center">
                <i class="fa fa-circle-info ms-3 ps-1" :class="'text-danger'"></i>
                <strong class="text-danger ms-2">Resolve the following validation errors</strong>
            </div>
            <div class="validation-card">
                <ul class="list-unstyled error-list">
                    <div v-if="validating" class="d-flex align-items-center justify-content-center">
                        <div class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <li v-for="(error, index) in errors" :key="index">
                            <span class="fa fa-circle-xmark mt-1 me-2 text-danger"></span>
                            {{ error }}
                        </li>
                    </div>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import JobEditor from '../components/sandbox/JobEditor.vue';
export default ({
    name: "ConfigValidation",
    components: { JobEditor },
    data() {
        return {
            yamlContent: this.content,
            activetab: this.activeTab,
        }
     },
    props: {
        editMode: {
			type: Boolean,
			default: true,
		},
        jobType: {
            type: String,
            default: ""
        },
        content: {
            type: Object,
            default: () => ({})
        },
        activeTab: {
            type: String,
            default: ""
        },
        errors:{
            type: Array,
            default: () => []
        },
        validating: {
			type: Boolean,
			default: false,
		},
    },
    methods: {
        onLintFailure(isError) {
            this.$emit("onLintFailure", isError);
        },
        showTab(val) {
            this.activetab = val;
        },
    },
    emits: ['onLintFailure', 'tabChange']
})
</script>
<style scoped>
.validation-card {
    background-color: #fff4f4;
    border-radius: 3px;
    border-left: 4px solid #dc3545;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 1rem;
    margin-top: 0.35rem;
    overflow-y: auto;
    font-size: 14px;
}

.error-list li {
    margin-bottom: 0.5rem;
    line-height: 1.4;
    display: flex;
    align-items: flex-start;
}

.error-alert {
    border-radius: 3px;
    background-color: #fff4f4;
    height: 33px;
    text-transform: uppercase;
    border-left: 4px solid #dc3545;
}
</style>